import gql from 'graphql-tag'
import articleSimpleFields from './fragments/article-simple-fields.gql'
import { PUBLISHED_POST_STATES } from '~/constants/content'

const buildArticlesSimpleQuery = ({ statuses = PUBLISHED_POST_STATES }) => {
  return gql`
    query getArticles(
      $first: Int
      $after: String
      $includeFeatured: Boolean
      $excluded: [ID]
    ) {
      articles: memberships(
        first: $first
        after: $after
        where: {
          stati: [${statuses}]
          showOnlyFeaturedPosts: $includeFeatured
          notIn: $excluded,
          taxQuery: {
            taxArray: [
              {
                terms: ["public"]
                taxonomy: CATEGORY
                operator: NOT_IN
                field: SLUG
              }
            ]
          }
        }
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          ... articleSimpleFields
        }
      }
    }
    ${articleSimpleFields}
  `
}

export default buildArticlesSimpleQuery
